<template>
    <div class="footer li_none_style">
        <div class="footer-line-CB">
            <div>雲灣資訊有限公司</div>
        </div>
        <ul class="footer-line-contact">
            <li>
                <i class="icon-mobile">&nbsp;<a href="tel:0229346523">02-2934-6523</a></i>
            </li>
            <li>
                <i class="icon-contact">&nbsp;<a href="mailto:cibi@cloudybay.com.tw">cibi@cloudybay.com.tw</a></i>
            </li>
            <li>
                <i class="icon-location">&nbsp;<a href="https://goo.gl/maps/nxgGEH6spex" target="_blank">台北市文山區景文街41號7樓</a></i>
            </li>
            <li>
                <i class="icon-github">&nbsp;<a href="https://github.com/cloudybay" target="_blank">https://github.com/cloudybay</a></i>
            </li>
        </ul>
        <div class="footer-line">
            Copyright ©2020 Cloudybay Information Co., Ltd All rights Reserved.
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Footer',
        data () {
            return { }
        },
    }
</script>
